import { Card, CardContent, CardHeader, TextField } from '@mui/material'
import { ReactNode } from 'react'
import UnitAdornment from './UnitAdornment'

interface Props {
  title: ReactNode
  label: ReactNode
  unit: ReactNode
  result?: number | null
  hidden?: boolean
}
function ResultCard (props: Props) {
  const {
    title, label, unit, result, hidden,
  } = props

  const isHidden = (
    hidden
    || result === null
    || result === undefined
  )

  if (isHidden) return <></>

  return (
    <Card>
      <CardHeader title={title} />
      <CardContent>
        <TextField
          label={label?.toLocaleString()}
          disabled
          InputProps={{ endAdornment: <UnitAdornment unit={unit} /> }}
          value={result}
        />
      </CardContent>
    </Card>
  )
}

export default ResultCard
